import { Injectable } from '@angular/core';
import { CommodityQuery } from '../../../models/commodity-query';
import { FilterService } from '../services/filter.service';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { FilterAssist } from '../../../models/filter-assist';
import { Observable, of } from 'rxjs';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({
  providedIn: 'root'
})
export class CommodityFilterService extends FilterService<CommodityQuery> implements FilterAssistQuery<CommodityQuery> {

  private COMMODITY_FILTER = 'COMMODITY_FILTER';

  constructor() {
    super();
    this.registerFilters(this);
  }

  protected describe(terms: string): string {
    const display = terms.replace(/\*/g, '');
    return $localize`Filter for "${display}"`;
  }

  active(query: CommodityQuery): Observable<FilterAssist[]> {
    if (query.description) {
      return of([ {
        id: this.COMMODITY_FILTER,
        description: this.describe(query.description),
        score: 50,
        parameter: query.description,
        category: FilterCategoryEnum.ANY
      } ]);
    }
    return of([]);
  }

  apply(id: string, parameter: any, query: CommodityQuery): void {
    switch (id) {
      case this.COMMODITY_FILTER:
        query.description = '*' + parameter + '*';
        break;
    }
  }

  ids(): string[] {
    return [ this.COMMODITY_FILTER ];
  }

  match(terms: string): Observable<FilterAssist[]> {
    if (terms.length < 2) {
      return of([]);
    }
    return of([ {
      id: this.COMMODITY_FILTER,
      parameter: terms,
      score: 50,
      description: this.describe(terms),
      category: FilterCategoryEnum.ANY
    } ]);
  }

  unapply(id: string, query: CommodityQuery): void {
    switch (id) {
      case this.COMMODITY_FILTER:
        query.description = null;
        break;
    }
  }
}
